import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { CollectionCard } from '../collections/CollectionCard';
import { formatCollectionAndFieldName } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AppwriteDatabaseCollections extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    appWriteDataCollection: '',
    collectionsByexternaldb: [],
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabase({ projectId, externalDbUuid, version });
    this.setState({ appWriteDataCollection: this.props.dataConnector.externalDatabase });
    await actions.collectionListExternaldbs({ projectId, dbUuid: externalDbUuid, version });
    const { collectionList } = this.props.dataConnector;
    this.setState({ collectionsByexternaldb: collectionList });
  }
  handleCollection = () => {
    const { match, history } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/appwrite-datasource/${externalDbUuid}/create`,
    );
  };
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };

  renderCollectionCards = (item, index, collectionsWithDb) => {
    return (
      <span className={`card  ml-4 col-lg-4 d-flex`}>
        <div className="card-body">
          <div className="avatar__meta">
            {collectionsWithDb.some(
              (collection) =>
                collection.collectionName === formatCollectionAndFieldName(item.collectionName),
            ) ? (
              <h5 className="avatar__title js-user-name" title={item.collectionName}>
                {item.collectionName} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={item.collectionName}>
                {item.collectionName}
              </h5>
            )}

            <p>Number of fields: {Object.keys(item.fields).length}</p>
            {collectionsWithDb.some(
              (collection) =>
                collection.collectionName === formatCollectionAndFieldName(item.collectionName),
            ) ? (
              <div>
                <p>
                  Created At:{' '}
                  {this.formatDate(
                    new Date(
                      collectionsWithDb.find(
                        (collection) =>
                          collection.collectionName ===
                          formatCollectionAndFieldName(item.collectionName),
                      ).createdAt,
                    ),
                  )}
                </p>
                <p>
                  Updated At:{' '}
                  {this.formatDate(
                    new Date(
                      collectionsWithDb.find(
                        (collection) =>
                          collection.collectionName ===
                          formatCollectionAndFieldName(item.collectionName),
                      ).updatedAt,
                    ),
                  )}
                </p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
          </div>
        </div>
      </span>
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { appWriteDataCollection, collectionsByexternaldb } = this.state;
    const { completeData } = appWriteDataCollection ? appWriteDataCollection : '';
    const { dataConnector } = this.props;
    const { loadExternalDatabasePending } = dataConnector;
    const collectionsWithDb = collectionsByexternaldb.map((a) => ({
      collectionTitle: a.collectionTitle,
      collectionName: a.collectionName,
      createdAt: a.createdAt,
      updatedAt: a.updatedAt,
    }));
    return this.state.appWriteDataCollection ? (
      <CommonPageComponent>
        <ParentContentCard title="All Collections in  Appwrite Database" icon={'collection'}>
          <div className="d-flex flex-wrap">
            {completeData['tables'].map((item, index) => {
              return this.renderCollectionCards(item, index, collectionsWithDb);
            })}
          </div>
          <hr />
          <div className="text-right ml-3 mt-2">
            <button className="btn btn-theme-submit mr-4 mt-3" onClick={this.handleCollection}>
              <i className="wb webconnect-rocket"></i>
              &nbsp;Continue &nbsp;
            </button>
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader loading={loadExternalDatabasePending} size="20px" color="#303453" />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteDatabaseCollections);
